"use strict";

module.exports = function () {
  var span = this.allColumns.length;
  if (this.hasChildRow) span++;
  if (this.opts.selectable.mode) span++;
  return span;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/computed/colspan.js
// module id = 854
// module chunks = 0